// Plik: frontend/src/pages/admin/AdminDashboard.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Typography, Box, Grid, 
  Card, CardContent, CardActionArea, Avatar
} from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import AdminLayout from '../../components/admin/AdminLayout';

const AdminDashboard = () => {
  const navigate = useNavigate();
  
  const navigationCards = [
    {
      title: 'Lista Uczestników',
      description: 'Przeglądaj, edytuj i zarządzaj zarejestrowanymi uczestnikami.',
      icon: <PeopleIcon sx={{ fontSize: 32 }} />,
      color: '#1976d2',
      action: () => navigate('/admin/uczestnicy')
    },
    {
      title: 'Zarządzanie Terminami',
      description: 'Dodawaj, edytuj i zarządzaj dostępnymi terminami wizyt.',
      icon: <CalendarMonthIcon sx={{ fontSize: 32 }} />,
      color: '#2e7d32',
      action: () => navigate('/admin/terminy')
    },
    {
      title: 'Statystyki',
      description: 'Zobacz statystyki rejestracji i frekwencji.',
      icon: <BarChartIcon sx={{ fontSize: 32 }} />,
      color: '#ed6c02',
      action: () => navigate('/admin/statystyki')
    },
    {
      title: 'Ustawienia Strony',
      description: 'Edytuj treści stron publicznych, regulamin i stronę podziękowania.',
      icon: <SettingsIcon sx={{ fontSize: 32 }} />,
      color: '#7b1fa2',
      action: () => navigate('/admin/ustawienia')
    }
  ];
  
  return (
    <AdminLayout title="Dashboard">
      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" fontWeight={600} gutterBottom>
          Witaj w panelu administracyjnym
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Zarządzaj rejestracjami, terminami i ustawieniami systemu.
        </Typography>
      </Box>
      
      <Grid container spacing={3}>
        {navigationCards.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card 
              sx={{ 
                height: '100%',
                transition: 'all 0.2s ease-in-out',
                '&:hover': { 
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
                },
                borderTop: `3px solid ${card.color}`,
              }}
            >
              <CardActionArea onClick={card.action} sx={{ height: '100%', p: 2.5 }}>
                <CardContent sx={{ p: 0 }}>
                  <Avatar 
                    sx={{ 
                      bgcolor: `${card.color}15`, 
                      color: card.color,
                      width: 56, 
                      height: 56,
                      mb: 2
                    }}
                  >
                    {card.icon}
                  </Avatar>
                  <Typography variant="h6" component="h2" fontWeight={600} gutterBottom>
                    {card.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                    {card.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </AdminLayout>
  );
};

export default AdminDashboard;